var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgTicketingPending = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: 333333,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 6.98V16C22 17.1 21.1 18 20 18H6L2 22V4C2 2.9 2.9 2 4 2H14.1C14.04 2.32 14 2.66 14 3C14 3.34 14.04 3.68 14.1 4H4V16H20V7.9C20.74 7.75 21.42 7.42 22 6.98ZM16 3C16 4.66 17.34 6 19 6C20.66 6 22 4.66 22 3C22 1.34 20.66 0 19 0C17.34 0 16 1.34 16 3Z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgTicketingPending, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/TicketingPending.2e3296d9.svg";
export { ForwardRef as ReactComponent };